import styled from "styled-components";

export const HeaderText = styled.p`
  color: #333;
  font-size: 1.7em;
  margin: 24px 0 0;
`

export const SubHeaderText = styled.p`
  color: #333;
  font-size: 1.2em;
  font-weight: bold;
  padding: 4px 0;
  margin: 8px;
`

export const BodyText = styled.div`
  color: #333;
  margin: 8px;
  font-size: 0.9em;
`
export const CommonList = styled.ul`
  color: #333;
  font-size: 0.9em;
`